import React from "react";
import {
  EmptyHeadingRow,
  FeatureSubHeading,
  HideButtonContainer,
  SubscriptionFeatureContainer,
} from "./styles";
import CheckCircle from "assets/images/settings/checkCircle.svg";
import TextView from "../TextView";
import _ from "lodash";
import CloseIcon from '@mui/icons-material/Close';

export const SubscriptionFeatures = ({
  subscription,
  packages,
  features,
  closeComparison,
  style,
}) => {
  const packageData = packages.find((pkg) => pkg.name === subscription.name);

  return (
    <SubscriptionFeatureContainer
      isActive={subscription.is_active}
      isInfinity={subscription.sub_tier === 3}
      hasDiscount={!_.isEmpty(subscription.discount)}
      style={style}
    >
      {Object.entries(features).map(([heading, subHeadings]) => (
        <div key={heading}>
          <EmptyHeadingRow>{heading}</EmptyHeadingRow>
          {subHeadings.map((subHeading, index) => {
            const packageFeatures = packageData?.features[heading] || [];
            const value = packageFeatures[subHeading]?.value_display
              ? packageFeatures[subHeading]?.value_display
              : packageFeatures[subHeading]?.enabled;

            const isTrue = value == true;

            const isTextValue = typeof(value) == "string";

            const featureValue = isTextValue ? (
              <TextView>{value}</TextView>
            ) : isTrue ? 
              <img src={CheckCircle} alt="check" /> : <CloseIcon sx={{ width: "17px", height: "17px", color: "red" }}/>;
           
            return (
              <FeatureSubHeading
                key={index}
                isActive={subscription.is_active}
                aligned={true}
              >
                {featureValue}
              </FeatureSubHeading>
            );
          })}
        </div>
      ))}
      <HideButtonContainer>
        <TextView
          variant="text"
          color={subscription.is_active ? "#8F38EF" : "#565556"}
          style={{ cursor: "pointer" }}
          onClick={closeComparison}
        >
          Hide all features
        </TextView>
      </HideButtonContainer>
    </SubscriptionFeatureContainer>
  );
};
